// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { BarsOutlined } from '@ant-design/icons';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

// icons
const icons = { BarsOutlined };

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const help: NavItemType = {
  id: 'faqs',
  title: <FormattedMessage id="faqs" />,
  type: 'group',
  url: '/support/faqs',
  icon: icons.BarsOutlined
};

export default help;
